import {Fieldset} from '@smart/react-components';
import type {PropsWithChildren} from 'react';
import React, {useContext} from 'react';
import type {Maybe} from '../../../graphql';
import {FieldContext} from './field-wrapper';
import type {IWrapperProvider} from './types';

type FieldsetProps = React.ComponentProps<typeof Fieldset>;

interface IProps {
  tag?: string;
  required?: boolean;
  props?: Partial<FieldsetProps>;
  label?: Maybe<string>;
}

const GroupField = function ({
  tag,
  required,
  props,
  children,
  label,
}: PropsWithChildren<IProps>) {
  const {getLabel, disabled} = useContext<IWrapperProvider>(
    FieldContext as any,
  );

  return (
    <Fieldset
      label={tag ? getLabel(`legend.${tag}`, required, label) : undefined}
      {...props}
      error={disabled}
    >
      {children}
    </Fieldset>
  );
};

export default GroupField;
